import { Mutation, MutationTree } from "vuex";
import {
  OverlayMutation,
  OverlaySection,
  OverlayState
} from "@/components/overlay/types";
import {
  EpgItem,
  Episode,
  Movie,
  Season
} from "@/services/apiService/api.types";

export const mutations: MutationTree<OverlayState> &
  Record<OverlayMutation, Mutation<OverlayState>> = {
  [OverlayMutation.SetOverlayOpen](state, overlayStatus: OverlaySection) {
    state.OverlayOpen = overlayStatus;
  },
  [OverlayMutation.ClearOverlayOpen](state) {
    state.OverlayOpen = "";
  },
  [OverlayMutation.SetChannelEpg](state, epgList: EpgItem[]) {
    state.channelEpg = epgList;
  },
  [OverlayMutation.SetActiveEpgItem](state, epgItem: EpgItem) {
    state.activeEpgItem = epgItem;
  },
  [OverlayMutation.SetActiveVodItem](state, vod: Movie | Episode | null) {
    state.activeVodItem = vod;
  },
  [OverlayMutation.SetActiveVodItemDuration](state, duration: number | null) {
    state.activeVodItemDuration = duration;
  },
  [OverlayMutation.SetActiveVodItemProgressDuration](
    state,
    duration: number | null
  ) {
    state.activeVodItemProgressDuration = duration;
  },
  [OverlayMutation.SetTvShowMeta](state, metaData: Season[] | null) {
    state.tvShowMeta = metaData;
  },
  [OverlayMutation.SetActiveTranslation](state, langCode: string | null) {
    state.activeTranslation = langCode;
  },
  [OverlayMutation.SetActiveTranslationId](state, langId: number | null) {
    state.activeTranslationId = langId;
  }
};
